import { useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { route } from "../../../router/route";
import useDisplay from "../../../hooks/useDisplay";
import { useNavigate } from "react-router-dom";

function NoticeSwiper({ dataList }) {
  const swiperRef = useRef();
  const navigate = useNavigate();

  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: isMobile ? 190 : isTablet ? 500 : 900,
          marginLeft: isMobile ? 60 : 140,
        }}
      >
        <div style={{ width: "100%" }}>
          <Swiper
            onSwiper={(it) => {
              swiperRef.current = it;
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.snapIndex);
            }}
            slidesPerView={1}
            centeredSlides={true}
            spaceBetween={0}
            modules={[Pagination]}
          >
            {dataList?.length > 0 ? (
              dataList?.map((item) => {
                return (
                  <SwiperSlide key={item.id} style={{}}>
                    <LSRgH2HeadLine
                      onClick={() => {
                        navigate(route.customer_service_notice);
                      }}
                      style={{
                        color: "#fff",
                        fontSize: isMobile ? 12 : 18,
                        lineHeight: isMobile ? "14.4px" : "normal",
                        cursor: "pointer",
                        whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                        overflow: "hidden", // 넘치는 텍스트를 숨김
                        textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                      }}
                    >
                      {item.title}
                    </LSRgH2HeadLine>
                  </SwiperSlide>
                );
              })
            ) : (
              <SwiperSlide>
                <LSRgH2HeadLine
                  style={{
                    color: "#fff",
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "normal",
                  }}
                >
                  등록된 공지사항이 없습니다.
                </LSRgH2HeadLine>
              </SwiperSlide>
            )}
          </Swiper>
        </div>

        {dataList?.length > 1 ? (
          <img
            onClick={() => swiperRef.current?.slidePrev()}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: isMobile ? -40 : -84,
              width: isMobile ? 16 : 24,
              height: isMobile ? 16 : 24,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src={"/assets/icons/left_button_w.png"}
            alt="left_button_w"
          />
        ) : null}

        {dataList?.length > 1 ? (
          <img
            onClick={() => swiperRef.current?.slideNext()}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: isMobile ? -20 : -45,
              width: isMobile ? 16 : 24,
              height: isMobile ? 16 : 24,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src={"/assets/icons/right_button_w.png"}
            alt="right_button_w"
          />
        ) : null}
      </div>
    </>
  );
}

export default NoticeSwiper;
